var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2 app-wrapper"},[_c('div',{class:`app-${_vm.app.uuid}`}),_c('b-alert',{attrs:{"show":_vm.errorModal.show,"variant":"danger"}},[_vm._v("\n        "+_vm._s(_vm.errorModal.msg)+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }